import { User } from "@/types";
import isObject from "isobject";

import delay from "./delay";
import duration from "./duration";

function getUserId(user: User) {
  const val = user.contact_uri || "";
  return val.split(":")[1];
}

// returns an object in-place of any non-object value
function objectify(value: any) {
  return isObject(value) ? value : {};
}

async function spawnNotification(
  title: string,
  body?: string,
  ...rest: any
): Promise<void> {
  if (Notification.permission !== "granted") {
    await Notification.requestPermission();
  }
  new Notification(title, { body, ...rest });
}

function paginate(array: any[], page_size: number, page_number: number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function formatMoney(value: number = 0) {
  if (value) {
    const dollarValue = value.toFixed(2);
    return `$${dollarValue}`;
  } else {
    return "$0.00";
  }
}

export {
  delay,
  duration,
  getUserId,
  spawnNotification,
  objectify,
  paginate,
  formatMoney
};
